import React, { useState } from "react";

import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";

import { invokeMessage } from "src/bepaid/components/Message";
import DeleteModal from "src/bepaid/components/Modal/components/DeleteModal";
import styles from "./DeleteCardModal.module.scss";

const View = (props: any) => {
  const { extraInfo, deleteCard, toggleModal } = props;

  const { cardId = null } = extraInfo;

  const closeModal = () => {
    toggleModal(FetchModalID.DELETE_NEW_CARD_MODAL);
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteCard = () => {
    if (!cardId) {
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      deleteCard(cardId, (hasError: boolean) => {
        setIsLoading(false);
        closeModal();
        invokeMessage(
          hasError ? "error" : "success",
          hasError
            ? "Unable to delete card. Please try it again!"
            : "Card deleted."
        );
      });
    }, 2000);
  };

  return (
    <>
      <DeleteModal
        title={`Delete this card?`}
        isLoading={isLoading}
        description={
          <>
            <span>
              This will permanently delete this card
              <br />
              and it cannot be undone.
            </span>
            <br />
            <p className={styles.helperText}>
              Deleting this card will also delete any associated scheduled
              payments.
            </p>
          </>
        }
        yesLabel={`Yes, delete card`}
        yesLabelLoading={`Deleting card...`}
        noLabel={`No, keep card`}
        onYes={handleDeleteCard}
        onNo={closeModal}
      />
    </>
  );
};

export default View;
